import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const NavContent = styled.div<{col?:boolean}>`
  display:grid;
  grid-template-columns: ${props => props.col?"1fr 1fr 1fr 1fr":"1fr 1fr 1fr"};
  grid-column: span 4;
  gap:40px;
  

  ${mq(Devices.tablet)} {
    grid-template-columns: 1fr 1fr;
    gap:20px;
  }
  ${mq(Devices.mobile)} {
    grid-template-columns: 1fr;
    gap:20px;
    padding: 15px;
  }
`;